export { DMS_MODULE } from '../../constants';
export const NAME ='ServiceJobDetails';
export const SPLIT_SHARE_DETAILS='Split Share Details';
export const ID='ID';
export const SERVICE_JOB_ID = 'SERVICE_JOB_ID';
export const SERVICE_JOB_DESCRIPTION ='SERVICE_JOB_DESCRIPTION';
export const SERVICE_JOB_COMMENTS = 'SERVICE_JOB_COMMENTS';
export const BILL_TO='BILL_TO';
export const CRUMB_LABEL_KEY = 'edtServiceJobDetails';
export const SERVICE_JOB_SPLIT_BILLING = 'ServiceJobSplitBilling';
export const LABOR_OPERATION = 'ZakazkaPracovniPozice'
export const PARTS_LIST = 'ZakazkaNd'
export const EXT_LO_TABLE = 'ZakazkaCiziVykony'
export const ROW_SAVED = 'Row Saved';
export const ROW_EDIT_CLICKED= 'Row Edit Clikced';
export const ZAKAZKA_REZERVACE_ND = 'ZakazkaRezervaceNd';
export const SERVICE_JOB_COLS = {
    ID,
    SERVICE_JOB_ID,   
    SERVICE_JOB_DESCRIPTION,
    SERVICE_JOB_COMMENTS,
    BILL_TO,
};